import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { LifecycleListComponent } from './lifecycle-list/lifecycle-list.component'

export const lifecycleRoutes: Route[] = [
  {
    path: 'lifecycles',
    component: LifecycleListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'lifecycles/:id/edit',
    redirectTo: 'lifecycles/:id',
    pathMatch: 'full'
  },
  {
    path: 'lifecycles/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Lifecycle',
        nameSingular: 'Lifecycle',
        namePlural: 'Lifecycles',
        path: 'lifecycles',
        slug: 'taxonomies/lifecycles',
        title: 'Lifecycles'
      }),
      permission: 'readTaxonomies'
    }
  }
]
